export function coachingTracks(state) {
    return state.coachingTracks;
}

export function getCoachCoachingBlocks(state) {
  return state.coachCoachingBlocks;
}

export function dropIns(state) {
  return state.dropIns;
}

export function isDataLoaded(state) {
  if(state.isDropInDataLoaded && state.isCTDataLoaded) return true
  if(!state.isDropInDataLoaded && !state.isCTDataLoaded) return false
}

export function isCoachingBlocksDataLoaded(state) {
  return state.coachingBlocksDataLoaded
}

export function isDropInDataLoaded(state) {
  return state.isDropInDataLoaded;
}
export function isCTDataLoaded(state) {
  return state.isCTDataLoaded;
}

export function getRegisterDropInCoachingSession(state) {
  return state.registerDropInCoachingSession;
}
export function getRegisterDropInCoachingSessionDialog(state) {
    return state.registerDropInCoachingSessionDialog;
}
export function getRegisterDropInCoachingSessionLevel(state) {
    return state.registerDropInCoachingSessionLevel;
}
export function getRegisterDropInCoachingSessionLevelType(state) {
    return state.registerDropInCoachingSessionLevelType;
}
export function getRegisterDropInCoachingSessionLevelEvent(state) {
    return state.registerDropInCoachingSessionLevelEvent;
}
export function getRegisterDropInCoachingSessionLevelConfirmed(state) {
    return state.registerDropInCoachingSessionLevelConfirmed;
}
export function getRegisterDropInCoachingSessionLevelDialog(state) {
    return state.registerDropInCoachingSessionLevelDialog;
}
export function getConfirmWaitlistDialog(state) {
  return state.confirmWaitlistDialog;
}
export function getRegisterWaitlistDropInCoachingSessionConfirmed(state) {
  return state.registerWaitlistDropInCoachingSessionConfirmed;
}
export function getDropInCoachingSessionIsFullDialog(state) {
  return state.dropInCoachingSessionIsFullDialog;
}
export function getForceBack(state) {
  return state.forceBack;
}
export function getPreviousComponent(state) {
  return state.previousComponent;
}
export function getCancelDropInCoachingSessionDialog(state) {
  return state.calcelDropInCoachingSessionDialog;
}
export function getViewMoreDropInCoachingSessionDialog(state, props) {
  return state.viewMoreDropInCoachingSessionDialog;
}
export function getChangeRegistrationDropInDialog(state) {
  return state.changeRegistrationDropInDialog;
}

export function coachingblocks(state) {
  return state.coachingBlocks;
}
export function getRegisterCoachingTrack(state) {
    return state.registerCoachingTrack;
}
export function getRegisterCoachingTrackDialog(state) {
    return state.registerCoachingTrackDialog;
}
export function getConfirmRegisterCoachingTrackDialog(state) {
  return state.confirmRegisterCoachingTrackDialog;
}
export function getCancelRegisterCoachingTrackDialog(state) {
  return state.cancelRegisterCoachingTrackDialog;
}
export function getViewMoreCoachingTrackDialog(state) {
  return state.viewMoreCoachingTrackDialog;
}
export function getChangeRegistrationCtDialog(state) {
  return state.changeRegistrationCtDialog;
}


export function getRegisterMindBreak(state) {
  return state.registerMindBreak;
}
export function getRegisterMindBreakDialog(state) {
  return state.registerMindBreakDialog;
}
export function getViewMoreMindBreakDialog(state) {
  return state.viewMoreMindBreakDialog;
}
